<template>
  <v-container fluid>
    <page-header @menuClick="menuClicked" :menuItems="menuItems">
      {{ selectedTitle }}
    </page-header>
    <component :is="selectedComponent" :key="timestamp" />

    <v-dialog max-width="600" v-model="cancelClassesDialog">
      <v-card>
        <v-card-title> Cancel classes for the day </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="cancelDate"
            type="date"
            label="Choose a Date to cancel classes"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="cancelClassesDialog = false">Close</v-btn>
          <v-btn
            :loading="isAppLoading"
            :disabled="isAppLoading"
            @click="cancelClasses"
            color="primary"
            >Cancel All Classes For Selected Date</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewCancelClassesDialog">
      <v-card>
        <v-card-title> View Canceled classes </v-card-title>
        <v-card-text>
          <div class="d-flex">
            <v-text-field
              @change="loadCanceledClasses"
              v-model="viewCancelDate"
              type="date"
              label="Show canceled classes for this date"
            />
          </div>
          <v-sheet>
            <v-simple-table v-if="canceledSchedules">
              <tbody>
                <tr v-for="(schedule, index) in canceledSchedules" :key="index">
                  <td>{{ schedule.course.name }}</td>
                  <td>{{ schedule.startTime | formatTime }}</td>
                  <td>
                    <v-btn
                      :disabled="isAppLoading"
                      :loading="isAppLoading"
                      @click="undoCancelation(schedule)"
                      small
                      >Undo</v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <div v-else>
              <v-skeleton-loader type="image" />
            </div>
          </v-sheet>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="viewCancelClassesDialog = false">Close</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const PageHeader = () => import("@/components/common/PageHeader.vue");
const TeachersSchedules = () =>
  import("@/components/teacher/TeachersSchedules.vue");
const CoursesSchedules = () =>
  import("@/components/course/CoursesSchedules.vue");

import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  data: () => ({
    timestamp: Date.now(),
    cancelDate: null,
    viewCancelDate: null,
    cancelClassesDialog: false,
    viewCancelClassesDialog: false,
    canceledSchedules: null,
    selectedComponent: "CoursesSchedules",
    selectedTitle: "Course Schedules",
    menuItems: [
      {
        id: "course-schedules",
        text: "Course Schedules",
        icon: "mdi-calendar-outline",
        to: { name: "Calendar", params: { calendarName: "course" } },
      },
      {
        id: "teacher-availability",
        text: "Teachers Availabilities",
        icon: "mdi-calendar-outline",
        to: { name: "Calendar", params: { calendarName: "availability" } },
      },
      {
        id: "cancel-classes",
        text: "Cancel Classes",
        icon: "mdi-calendar-remove",
      },
      {
        id: "view-canceled-classes",
        text: "View Canceled Classes",
        icon: "mdi-card-search-outline",
      },
    ],
  }),
  components: {
    PageHeader,
    TeachersSchedules,
    CoursesSchedules,
  },
  filters: {
    formatDate(value) {
      return moment(value).format("ddd, MMM DD YYYY");
    },
    formatTime(value) {
      return moment(value, "HH:mm").format("h:mm a");
    },
  },
  computed: {
    ...mapGetters(["isAppLoading"]),
  },
  methods: {
    ...mapActions(["addErrorMessage", "addSuccessMessage"]),
    menuClicked(event, menu) {
      console.log(menu);
      if (menu.id == "cancel-classes") {
        console.log("cancel classes");
        this.cancelDate = moment().format("YYYY-MM-DD");
        this.cancelClassesDialog = true;
      } else if (menu.id == "view-canceled-classes") {
        this.viewCancelDate = moment().format("YYYY-MM-DD");
        this.loadCanceledClasses();
        this.viewCancelClassesDialog = true;
        console.log("view canceled classes");
      }
    },
    loadCanceledClasses() {
      this.canceledSchedules = null;
      
      const params = {
        date: this.viewCancelDate,
      };

      this.$axios
        .get("/course-schedule/view-cancel-classes", { params })
        .then((resp) => {
          this.canceledSchedules = resp.data.data;
        });
    },
    cancelClasses() {
      const params = {
        date: this.cancelDate,
      };

      this.$axios
        .post("/course-schedule/cancel-classes", null, { params })
        .then((resp) => {
          console.log(resp.data);
          this.addSuccessMessage("Classes Canceled.");
          this.timestamp = Date.now();
          this.cancelClassesDialog = false;
        })
        .catch((error) => {
          this.addErrorMessage(
            error.data.message | `Error canceling classes on ${this.cancelDate}`
          );
        });
    },
    undoCancelation(schedule) {
      const data = {
        courseScheduleId: schedule.id,
        date: this.viewCancelDate,
      };
      this.$axios
        .post("/course-schedule/undo-cancel-class", data)
        .then(() => {
          this.addSuccessMessage("Class restored");
          this.timestamp = Date.now();
          this.canceledSchedules.splice(this.canceledSchedules.findIndex(cs => cs.id == schedule.id), 1);
        })
        .catch(() => {
          this.addErrorMessage(
            "Oops! something went wrong, please try again later."
          );
        });
    },
  },
  mounted() {
    const calendarName = this.$route.params.calendarName;

    if (calendarName == "availability") {
      this.selectedComponent = "TeachersSchedules";
      this.selectedTitle = "Teachers Availabilities";
    } else {
      this.selectedComponent = "CoursesSchedules";
      this.selectedTitle = "Course Schedules";
    }
  },
};
</script>